import { render, staticRenderFns } from "./NumberModal.vue?vue&type=template&id=08028b44"
import script from "./NumberModal.vue?vue&type=script&lang=js"
export * from "./NumberModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports